import { Route as PublicRoute } from 'react-router-dom';

import { Alerts } from '../lazyLoaded';
import { PATH_NAME } from '../pathNames';

const AlertsRoute = () => (
  <PublicRoute
    exact
    path={PATH_NAME.ALERTS}
    component={(props: JSX.IntrinsicAttributes) => <Alerts {...props} />}
  />
);
export default AlertsRoute;
